import './PageQrCode.css.proxy.js';
/* src/components/PageQrCode.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { onMount } from "../../web_modules/svelte.js";
import QrCode from "../../web_modules/svelte-qrcode.js";

function create_if_block(ctx) {
	let qrcode;
	let current;

	qrcode = new QrCode({
			props: {
				value: /*url*/ ctx[0],
				level: "M",
				size: 200
			}
		});

	return {
		c() {
			create_component(qrcode.$$.fragment);
		},
		l(nodes) {
			claim_component(qrcode.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(qrcode, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const qrcode_changes = {};
			if (dirty & /*url*/ 1) qrcode_changes.value = /*url*/ ctx[0];
			qrcode.$set(qrcode_changes);
		},
		i(local) {
			if (current) return;
			transition_in(qrcode.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(qrcode.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(qrcode, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current;
	let if_block = /*url*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if (if_block) if_block.l(div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "container svelte-1nansa0");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*url*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*url*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div, null);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let url;

	onMount(() => {
		$$invalidate(0, url = window.location.href);
	});

	return [url];
}

class PageQrCode extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default PageQrCode;
//# sourceMappingURL=PageQrCode.js.map
